/**
 * Persistent banner shown whenever an admin is impersonating another user.
 * Mounted globally in App.js so it's visible on every route while active.
 */
import React from 'react';
import { toast } from 'sonner';
import { getImpersonationInfo, exitImpersonation } from '@/utils/impersonation';
import { Eye, SignOut } from '@phosphor-icons/react';

export default function ImpersonationBanner() {
  const info = getImpersonationInfo();
  if (!info) return null;

  const handleExit = () => {
    const redirect = exitImpersonation();
    toast.success('Exited impersonation');
    // Full reload so AuthContext re-reads auth_token from scratch.
    window.location.href = redirect;
  };

  const typeLabel = info.type === 'institution' ? 'Institution' : 'Recruiter';

  return (
    <div
      className="w-full bg-amber-500 text-amber-950 border-b border-amber-700 shadow-sm"
      data-testid="impersonation-banner"
      style={{ position: 'sticky', top: 0, zIndex: 60 }}
    >
      <div className="max-w-[1600px] mx-auto px-4 py-2 flex items-center justify-between gap-3 text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <Eye size={16} weight="bold" className="shrink-0" />
          <span className="truncate">
            Impersonating <strong className="font-semibold" data-testid="impersonation-target-name">{info.name}</strong>
            <span className="hidden sm:inline text-amber-900/80"> · {typeLabel}{info.email ? ` · ${info.email}` : ''}</span>
          </span>
        </div>
        <button
          onClick={handleExit}
          data-testid="exit-impersonation-btn"
          className="shrink-0 inline-flex items-center gap-1.5 bg-amber-900 hover:bg-amber-950 text-white text-xs font-semibold rounded-md px-3 py-1.5 transition-colors"
        >
          <SignOut size={14} weight="bold" /> Exit
        </button>
      </div>
    </div>
  );
}
